// extracted by mini-css-extract-plugin
module.exports = {"integrationBanner":"integration-setting_integrationBanner__2E50n"};